import React, { useState } from 'react';
import { useStringsContext } from '../../../../../contexts/strings';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import { SquadPlayer } from '../../types';

interface Props {
  selectedSquad: SquadPlayer[];
  isLoading: boolean;
  player: SquadPlayer | null;
  onSelectedPlayer: (player: SquadPlayer) => void;
  disabled?: boolean;
}

const PlayerSelect = ({ selectedSquad, isLoading, player, onSelectedPlayer, disabled }: Props) => {
  const { strings } = useStringsContext();
  const [selectedPlayer, setSelectedPlayer] = useState(player);

  const onChange = (event: SelectChangeEvent) => {
    const clId = event.target.value as string;
    const newSelectedPlayer = selectedSquad.find((squadPlayer) => squadPlayer.clId === clId);
    if (newSelectedPlayer) {
      setSelectedPlayer(newSelectedPlayer);
      onSelectedPlayer(newSelectedPlayer);
    }
  };

  return (
    <>
      {!isLoading ? (
        <FormControl fullWidth>
          <InputLabel size="small">{strings.squad.selectPlayer}</InputLabel>
          <Select
            size="small"
            value={selectedPlayer?.clId || ''}
            label={strings.squad.selectPlayer}
            onChange={onChange}
            disabled={disabled}
          >
            {(selectedSquad || []).map((squadPlayer) => (
              <MenuItem key={squadPlayer.clId} value={squadPlayer.clId}>
                {squadPlayer.displayName || squadPlayer.fullName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <CircularProgress size="15px" />
      )}
    </>
  );
};

export default PlayerSelect;
